/**
 * chatbic-api-beta
 * CHAT Services API - Use this API to access the CHAT Services of the Building Information Cloud (BIC).
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { LoadRequest } from '../model/loadRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DefaultService {

    protected basePath = 'https://services.thinkbic.de/chatbic-beta';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Get Identity for User
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateIdentity(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public generateIdentity(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public generateIdentity(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public generateIdentity(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/identity`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get Token for User
     * @param identity 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateToken(identity: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public generateToken(identity: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public generateToken(identity: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public generateToken(identity: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (identity === null || identity === undefined) {
            throw new Error('Required parameter identity was null or undefined when calling generateToken.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (identity !== undefined && identity !== null) {
            queryParameters = queryParameters.set('identity', <any>identity);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/token`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Add new Information to Search
     * @param x_api_key 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public load(x_api_key: string, body?: LoadRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public load(x_api_key: string, body?: LoadRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public load(x_api_key: string, body?: LoadRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public load(x_api_key: string, body?: LoadRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (x_api_key === null || x_api_key === undefined) {
            throw new Error('Required parameter x_api_key was null or undefined when calling load.');
        }


        let headers = this.defaultHeaders;
        if (x_api_key !== undefined && x_api_key !== null) {
            headers = headers.set('x-api-key', String(x_api_key));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/load`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Add new Information to Search
     * @param x_api_key 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadIfc(x_api_key: string, body?: LoadRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public loadIfc(x_api_key: string, body?: LoadRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public loadIfc(x_api_key: string, body?: LoadRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public loadIfc(x_api_key: string, body?: LoadRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (x_api_key === null || x_api_key === undefined) {
            throw new Error('Required parameter x_api_key was null or undefined when calling loadIfc.');
        }


        let headers = this.defaultHeaders;
        if (x_api_key !== undefined && x_api_key !== null) {
            headers = headers.set('x-api-key', String(x_api_key));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/load_ifc`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
